module.exports = __webpack_public_path__ + "img/login-indorock.61d840bb.svg";